import type { DmTriageSetter } from '../../../../services/dmMessagesInbox';
import { formatDateTime } from '../../../../utils/dates';

// Undefined (no tooltip) while only the list's triage summary is known.
export function triageSetByText(
    setBy: DmTriageSetter | null | undefined,
    setAt: string | null | undefined
): string | undefined {
    if (setBy === undefined) return undefined;
    if (!setBy && !setAt) return 'Not set by anyone yet';
    const who = setBy?.fullname?.trim() || setBy?.email || 'Someone';
    const when = formatDateTime(setAt);
    return when ? `Set by ${who} · ${when}` : `Set by ${who}`;
}
